<template>
  <div class="rhg-search-map-destinations-landing" :class="{'rhg-search-map-position': !viewMap}" data-testid="destination-page-view">
    <div v-if="!viewMap" class="rhg-destinations-searchbar" data-testid="destination-sb-view">
      <button ref="SBButton" @click="toggleViewMap" class="rhg-search-destination-button" data-testid="see-full-map-button">
        <span class="rhg-search-destination-button-label">{{ translate('desSearchSeeFullMap') }}</span>
        <i class="rhg-font-icon--arrow-right rhg-btn__arrow rhg-btn__arrow-right"></i>
      </button>
    </div>
    <div v-if="viewMap" class="rhg-search-destinations-map" data-testid="map-view">
      <button ref="mapButton" @click="toggleViewMap" class="rhg-search-destination-button rhg-search-destination-button--margin-top" data-testid="close-map-button">
        <i class="rhg-font-icon--arrow-left rhg-btn__arrow rhg-btn__arrow-left"></i>
        <span class="rhg-search-destination-button-label">{{ translate('desSearchForADestination') }}</span>
      </button>
      <div class="rhg-map-destinations">
        <Map
            :hotels="hotels"
            @hotelsInView="showHotelMap"
            @onBookNow="onBookNow"
            @openSBCalendar="openSBCalendar"
            />
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { hotelMixin } from '@/infrastructure/HotelsInMap.js'
const { mapActions } = createNamespacedHelpers('discovery')

export default {
  name: 'Destination',
  components: {
    Map: () => import('@/components/discovery/map/Map')
  },
  data: () => ({
    viewMap: false
  }),
  mixins: [hotelMixin],
  methods: {
    ...mapActions([
      'getDestinationHotels'
    ]),
    openSBCalendar(hotel) {
      global.appGlobalProps.page = 'destination'
      if (hotel && hotel.name && hotel.code) {
        global.appGlobalProps.hotelName = hotel.name
        global.appGlobalProps.hotelCode = hotel.code
      }
      global.searchBarVue.$emit('show-modal-modify-dates')
    },
    toggleViewMap() {
      this.viewMap = !this.viewMap
      const destinationSB = document.getElementById('destinations-landing-hero')
      if (destinationSB) {
        if (!destinationSB.classList.contains('rhg-d-none')) {
          destinationSB.classList.add('rhg-d-none')
        } else {
          destinationSB.classList.remove('rhg-d-none')
        }
      }
    },
    async fetchZimbaHotelsAndAnalytics() {
      try {
        await this.getDestinationHotels()
      } catch (e) {
        global.$('#modal-error').modal('show')
      } finally {
        this.$store.dispatch('sendAnalyticsView')
      }
    }
  },
  async created () {
    await this.fetchZimbaHotelsAndAnalytics()
  }
}
</script>

<style lang="scss">
  .rhg-search-map-destinations-landing {
    background-color: #29343D;
  }
.rhg-search-map-position {
    margin-top: -600px;
  }
  .rhg-destinations-searchbar {
    max-width: 618px;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: end;

    .rhg-search-destination-button {
      top: 520px;
      position: relative;
      padding-right: 20px;
      word-break: break-all;
      @media(min-width: 660px) {
        padding-right: initial
      }
    }
  }
  .rhg-search-destinations-map {
      @media (min-width: 992px) {
        margin: auto;
      }
      background-color: #29343D;
      padding-bottom: 40px;
      width: 100%;
      max-width: 1344px;
      min-height: 625px;
      height: 100%;

    .rhg-map-destinations {
      border-radius: 8px;
      border: 1px solid #D1D1D1;
      overflow: hidden;
    }
  }
  .rhg-search-destination-button {
      font-size: 14px;
      font-weight: 700;
      line-height: 18px;
      text-transform: uppercase;
      color: white;
      margin: 20px 0;
      border: 0;
      background-color: transparent;
      padding: 0px;
      display: flex;
      align-items: center;
      gap: 8px;
      outline: none !important;
      box-shadow: none !important;

      &--margin-top {
        margin-top: 44px;
      }
    }
    .rhg-search-destination-button-label:hover {
      text-decoration: underline;
    }

  html[dir="rtl"]{
    .rhg-btn__arrow-left {
      transform: rotate(180deg);
    }
    .rhg-search-destination-button {
      padding-right: initial;
      padding-left: 20px;
      @media(min-width: 660px) {
        padding-left: initial
      }
    }
  }
</style>
